export const NODE_URL = "https://fullnode.devnet.aptoslabs.com";